// A nested structure should be used to easily find elements later
const i18n_de = {
  translation: {
    menu: {
      definition: 'Die Idee',
      liste: 'Die Weltliste',
      worldmodel: 'Das Weltmodell',
      konzept: 'Das Konzept',
      about: 'Über uns',
      buecher: 'Die Bücher',
      reisen: 'Die Reisen',
      kommentare: 'Resonanz',
      impressum: 'Impressum',
      datenschutz: 'Datenschutz',
      privacysettings: 'Privatsphäre-Einstellungen',
    },
    // ================== Welcome page (Home page) + its sections  
    welcome: {
      hero: {
        subtitle: 'Auf der Suche nach Extremen',
        h1: 'Die ganze Welt in 6.000 Highlights',
        img: {
          src: '/Img/Welcome/01_Flussgabelung.jpg',
          alt: ''
        }
      },
      definition: {
        h2: 'Die Idee',
        text: 'Die Frank Grosse World Highlights List erfasst die ganze Welt in 6.000 Welthighlights <strong>– systematisch und objektiv.</strong>',
        buttonLink: 'definition',
        buttonText: 'Zur Idee',
        img: {
          src: '/Img/Welcome/02_Trockentaeler.jpg',
          alt: '',
          width: '500px',
          // height: '253px'
        }
      },
      liste: {
        h2: 'Die Weltliste',
        text:
          [
            'Sie erfasst die wesentlichen Merkmale der Highlights',
            'als Tabelle: Lokalisierung, Bewertung, Kategorie',
            'als Übersicht: Beschreibung, Besuchsdaten',
            'Google maps und Fotos'
          ],
        buttonLink: 'worldlist',
        buttonText: 'Zur Weltliste',
        img: {
          src: [
            '/Img/Welcome/03_Liste.webp', // Preferred WebP (for Mockups)
            '/Img/Welcome/03_Liste.png'   // Fallback JPG/PNG
          ],
          alt: '',
          width: '558px',
          height: '398px'
        }
      },
      worldmodel: {
        h2: 'Das Weltmodell',
        text:
          [
            'es erfasst die Welt ganzheitlich,',
            'in 1500 Kategorien,',
            'das Weltextrem für jede Kategorie,',
            'die Top Ten Welthighlights für jede Kategorie,',
            'die Top Ten Arten für jede Kategorie.',
            'Es bezieht alle Erscheinungen auf die Kategorie, nicht auf einen Ort.'
          ],
        buttonLink: 'worldmodel',
        buttonText: 'Zum Weltmodell',
        img: {
          src: '/Img/Welcome/Weltmodell.png',
          alt: '',
          width: '516px',
          // height: '398px'
        }
      },
      konzept: {
        h2: 'Das Konzept',
        text:
          [
            'Reiselust als höchstes Reiseziel',
            'Kriterien für die Auswahl',
            'Bewertung und Rangfolge',
          ],
        buttonLink: 'concept',
        buttonText: 'Zum Konzept',
        img: {
          src: '/Img/Welcome/04_Reisefreude.jpg',
          alt: '',
          width: '516px',
          height: '398px'
        }
      },

      about: {
        h2: 'Über uns',
        text:
          [
            'Reisen in Partnerschaft',
            'Der Schock',
            'Der letzte Abschnitt galt Extremen',
            'Das Ende der Karriere',
            'Unsere Bewertungen'
          ],
        buttonLink: 'about',
        buttonText: 'Über uns',
        img: {
          src: '/Img/Welcome/05_Harmonie.jpg',
          alt: '',
          width: '516px',
          height: '398px'
        }
      },

      travels: {
        h2: 'Unsere Reisen',
        text:
          [
            'Reisen zur ganzen Welt',
            'Welthighlights sind die Reiseziele',
            'Reisequalität und Reiseeffizienz gleichzeitig',
            'Reisen mit einem individuellen Sinnprofil',
            'Reisen mit dem Oberziel der Freude',
          ],
        buttonLink: 'travels',
        buttonText: 'Unsere Reisen',
        img: {
          src: '/Img/Welcome/07_Reisen.jpg',
          alt: '',
          width: '516px',
          // height: '398px'
        }
      },

      books: {
        h2: 'Die Bücher',
        text:
          [
            'Die Bücher behandeln unser Know-how in 5 Bänden: Erfolgskonzept, Umsetzung, Training, Vorbilder, Autobiographie',
            'Band 1 und 2 behandeln das Fundament dieser Webseite, die anderen 3 ergänzen das Fundament',
            'Band 1: Das Erfolgskonzept, Band 2: Seine Umsetzung',
          ],
        buttonLink: 'book',
        buttonText: 'Zu den Büchern',
        img: {
          src: '/Img/Welcome/06_Buecher.jpg',   // Fallback JPG/PNG
          alt: '',
          width: '578px',
          height: '409px'
        }
      }
    },

    // ===================== Definition page + sections  
    definition: {
      hero: {
        subtitle: 'Auf der Suche nach Einzigartigem',
        h1: 'Die Idee der Weltliste',
        text: [
          '<strong>Sie erfasst alles Wesentliche der Welt, Erscheinungsformen, die superlativ, einzigartig oder typisch sind. Sie entsteht empirisch aus Beobachtung und Erfahrung – induktiv: Was ist? Und sie ordnet analytisch durch Kategorisierung – deduktiv: Was könnte sein? So entstehen die zentralen Richtwerte „6.000 Highlights“ und „1.500 Kategorien“ und damit der Maßstab für den, der die ganze Welt sehen will.</strong>'
        ],
        img: {
          src: '/Img/Welcome/01_Flussgabelung.jpg',
          alt: '',
          caption: 'Alexander von Humboldts Reiseziel<br />Die größte Flussgabelung der Welt',
        },
        EnumerateTag: 'p',
      },
      warum6000Highlights: {
        element: 'Line',
        h2: 'Warum 6.000 Welthighlights?',
        text: [
          '<strong>Extreme:</strong><br>Diese Zahl umfasst die ganze Welt in ihren Extremen: Superlative, Einzigartiges, Typisches.<br/><br/>',
          '<strong>Machbar:</strong><br>Diese Zahl kann man in einem Reiseleben mit Freude und sinnvoller Qualität besuchen. Wir haben das bewiesen.'
        ],
        img: {
          src: '/Img/Definition/02 Naturgenuss.jpg',
          alt: '',
          width: '450px',
          caption: 'Humboldts Naturgenuss',
        },
        img2: {
          src: '/Img/Definition/03 Erlebniswelt.jpg',
          alt: '',
          width: '450px',
          caption: 'Humboldts Erlebniswelt',
        }
      },
      minMax: {
        element: 'TwoColumn',
        text: [
          '<strong>Maximum:</strong><br>Kann man mehr als 6.000 sehen?<br>Vielleicht, aber bisher hat noch keiner mehr besucht. Augenblicklich ist es der Höchstwert.',
          '<strong>Minimum:</strong><br>Im Literaturvergleich zeigt sich: 2.000 Highlights sind das Minimum für die ganze Welt'
        ]
      },
      traumblick: {
        element: 'WideImage',
        img: {
          src: '/Img/Definition/04_Traumblick.jpg',
          alt: '',
          caption: 'Humboldts Traumblick, Caracas vom Avila, Humboldt-Hotel',
        },
      },
      einzigartig1: {
        h2: 'Warum ist die Benutzung der Weltliste einzigartig?',
        text: [
          '<strong>Interaktiv:</strong><br>Die Liste bietet weltweit einzigartige Auswahl- und Sortiermöglichkeiten mit einer dynamischen Auswahllogik und einer extremen Benutzerfreundlichkeit ohne jeglichen Fachjargon.<br /><br />',
          '<strong>Umfang:</strong><br>Diese Liste ist etwa fünfmal so umfangreich wie die UNESCO-Welterbe-Liste, denn sie umfasst die ganze Welt und nicht wie das Welterbe nur einen Teil der Welt.'
        ],
        img: {
          src: '/Img/Definition/05 Trockentaeler.jpg',
          alt: '',
          width: '450px',
          caption: 'Die Trockentäler der Antarktis',
        },
        img2: {
          src: '/Img/Definition/06 Japanburg.jpg',
          alt: '',
          width: '450px',
          caption: 'Das Matsuyama Castle in Japan',
        }
      },
      besuchsziele: {
        element: 'TwoColumn',
        text: [
          '<strong>Besuchsziele:</strong><br>Die Liste enthält das gesamte UNESCO-Welterbe, aber oft nicht als große Schutzgebiete, sondern als genau definierte und bewertete Besuchsziele. 40% des Welterbes wurden auf dieses Ziel hin fokussiert oder erweitert. In der Liste wird die Beziehung zum Welterbe genau aufgezeigt.',
          '<strong>Ultimativ:</strong><br>Die ganze Welt wird in einer einzigen Liste erfasst: Burgen, Vulkane, Bars, Dokumente, Museen, Strände, Feste, Ethnien, Flüsse, Vergnügen, Discos. Die ultimative Weltliste, die man lustvoll in einem Reiseleben bereisen kann.'
        ]
      },
      markt_abbey: {
        align: false,
        img: {
          src: '/Img/Definition/07 Anfahrt zum Markt.jpg',
          alt: '',
          width: '550px',
          caption: 'Anfahrt zum Markt in Ganvie, Benin',
        },
        img2: {
          src: '/Img/Definition/08 Schottisches Kloster.jpg',
          alt: '',
          width: '450px',
          caption: 'Iona Abbey in Schottland, Hebriden',
        }
      },
      einzigartig2: {
        h2: 'Warum ist der Inhalt der Weltliste einzigartig?',
        text: [
          '<strong>Qualität:</strong><br>Der Liste liegen zwei Bücher zugrunde, die Konzept, Philosophie und Umsetzungsprozess umfassend erläutern.<br /><br />',
          '<strong>Systematik:</strong><br>Die Liste ist so objektiv wie möglich, die Objektivität beruht auf einer konsistenten Systematik.<br /><br />',
          '<strong>Maßstab:</strong><br>Die Liste ist der Maßstab für Reisequalität, weil die „Besten“ ausgewählt wurden, meist 5-10 Highlights pro Kategorie, der Grenzbereich liegt zwischen 3-20 Highlights.<br /><br />',
        ],
        img: {
          src: '/Img/Definition/09 Teo im Eistunnel.jpg',
          alt: '',
          width: '450px',
          caption: 'Teo im Eistunnel der Ostantarktis',
        },
        img2: {
          src: '/Img/Definition/10 Autor mit Anaconda.jpg',
          alt: '',
          width: '450px',
          caption: 'Der Autor mit einer Anaconda, Venezuela',
        }
      },
      kategorien: {
        element: 'SingleColumn',
        align: false,
        text: [
          '<strong>Kategorien:</strong><br>Die Highlights werden 1.500 Kategorien zugeordnet. So wird ihr Wesen grob erfasst. Innerhalb der Kategorie sind sie miteinander vergleichbar. Somit ergibt sich eine Rangfolge.<br /><br />',
          '<strong>Wesentlich:</strong><br>Die „Beschreibung“ erläutert das Wesen des Highlights mit klaren Kriterien. Mit den bedeutendsten Kriterien lassen sich  schließlich numerische Rangfolgen bilden, zunächst nach Mega, Top und Standard-Highlights und dann mit spezifischen Kriterien genauer.<br /><br />',
        ],
      },
      ganzeinheitlich: {
        element: 'SingleColumn',
        width: 60,
        align: false,
        h2: 'Warum ist die Weltliste ganzheitlich?',
        text: [
          'Dies wird durch die ganzheitliche Kategorisierung - <strong>Taxonomie</strong> - erreicht und durch eine <strong>umfassende Lokalisierung: Ausgangsort</strong> - ein praktischer Ausgangspunkt für den Besuch, <strong>Unterorte</strong> sind Teile des Highlights, deren Besuch das volle Wesen des Highlights erschließt und <strong>Zusatzorte</strong>: Ihr Besuch liegt am Wege, ergänzt das Erlebnis, ist aber optional, nur wenn es Zeit und Logistik erlauben.',
          // 'Sie zielt auf <strong>die ganze Welt</strong> und auf <strong>das ganze Reiseleben.<br/><br />',
          // '<strong>Sie definiert Highlights so, dass diese beiden Ziele erreicht werden</strong>, ohne sich zu verzetteln. Das unterscheidet sie von allen anderen Listen.<br/><br />',
          // '<strong>Sie definiert Highlights so, dass Reisen Erleben bedeutet</strong> und nicht nur Orte zu sehen, fotografieren, teilen und abzuhaken.<br/><br />',
          // 'Das wird in Unter-, Zusatz- und Ausgangsorten und der Kategorisierung berücksichtigt.<br/><br />',
        ],
      },
      reisen: {
        element: 'Box',
        EnumerateTag: 'li',
        h2: 'Reisen heißt,',
        text: [
          'das Wesen des Ortes zu verstehen',
          'den Besuch mit ästhetischen und ethischen Werten zu leiten',
          'den Ort mit allen Arten der Wahrnehmung zu erleben',
          'im Besuch Sehen, Fühlen, Hören, Vorstellen gleichzeitig zu realisieren',
        ]
      },
      evangelisten: {
        element: 'ImageArray',
        align: false,
        images: [
          {
            src: '/Img/Definition/11a Matthaeus.jpg',
            alt: '',
            width: '250px',
          },
          {
            src: '/Img/Definition/11b Markus.jpg',
            alt: '',
            width: '250px',
          },
          {
            src: '/Img/Definition/11c Lukas.jpg',
            alt: '',
            width: '250px',
          },
          {
            src: '/Img/Definition/11d Johannes.jpg',
            alt: '',
            width: '250px',
          },
        ]
      },
      evangelisten_text: {
        element: 'SingleColumn',
        width: 80,
        class: 'smalltext',
        text: [
          'Die vier Evangelisten Matthäus, Markus, Lukas und Johannes von Tilman Riemenschneider im Bode-Museum in Berlin nehmen alle verschieden wahr: Matthäus sieht, Markus fühlt, Lukas hört, Johannes lehrt, aber sie verarbeiten die verschiedenen Sinneseindrücke zu einer gemeinsamen ganzheitlichen Wahrnehmung<br />zum Zustand der Erleuchtung, der Erkenntnis des Ganzen, des höchsten Wertes<br />sie erleben Gott<br />und sie erleben Freude, subtil, aber tief -<br />die beste Holzschnitzarbeit aller Zeiten.<br />Und darum geht es beim Reisen, um Freude, wenn auch die weltliche Freude deutlich ausgelassener daherkommt, so kommt sie doch aus der Ganzheitlichkeit im Gegensatz zum Spaß, der aus dem oberflächlichen Reiz kommt.'
        ]
      },
      humboldt: {
        element: 'Box',
        h2: 'Diese ganzheitliche Sicht beim Reisen wurde von Alexander von Humboldt erfunden',
        EnumerateTag: 'li',
        text: [
          '„Alles ist Wechselwirkung“',
          '„Die Natur als lebendiger Organismus“ und nicht ein mechanisches Gebilde, damals die „Weltenuhr“.',
          'So erfand er das Lebensnetz, die Globalisierung, die Ökologie, das Mobile des Denkens.',
          'Seinerzeit eine Revolution, heute für uns eine Selbstverständlichkeit.'
        ],
        footer: 'Das größte Genie aller Zeiten. Ihm zu Ehren haben wir mit vier Bildern aus seiner Sicht auf die Welt begonnen:<br />Flussgabelung, Naturgenuss, Erlebniswelt, Traumblick.',
      },
      worumesnichtgeht: {
        element: 'Accordion',
        width: 60,
        align: true,
        h2: 'Worum es nicht geht',
        elements: [
          {
            header: 'Es geht nicht um Formalismen, sondern um Inhalte',
            text: 'Highlights erfassen Inhalte, also Orte, Plätze, Stätten, keine Formalismen wie Regionen, Grenzen, Ufer. Sie zeigen, was man erleben sollte, und nicht, dass man Grenzen überschreiten oder Inseln betreten sollte.',
            images: [
              {
                src: '/Img/Definition/Akkordeon/1a.gif',
                alt: '',
                width: '200px',
                height: '159px',
                subtitle: 'Nicht Linien',
              },
              {
                src: '/Img/Definition/Akkordeon/1b.jpg',
                alt: '',
                width: '200px',
                height: '150px',
                subtitle: 'sondern Inhalte',
              },
            ]
          },
          {
            header: 'Es geht nicht um viele Listen, sondern um eine einzige',
            text: 'Es gibt Organisationen, die bieten viele Listen zu Reisezielen an, um so individuelle Interessen zu berücksichtigen. Wir dagegen wollen alles objektiv Wichtige in einer einzigen Liste integrieren. Wir wollen Objektivität und nicht Subjektivität. Die UNESCO bietet drei Listen an, weil die Inhalte der Reiseziele unterschiedlich sind, z.B. materielle und immaterielle. Aber alles muss sich in einem Ort manifestieren, wenn es ein Reiseziel sein soll. Alles lässt sich in einer Liste integrieren. Nur eine einzige Liste behält den Überblick.',
            images: [
              {
                src: '/Img/Definition/Akkordeon/2a.png',
                alt: '',
                width: '150px',
                height: '145px',
                subtitle: 'Nicht mehrere',
              },
              {
                src: '/Img/Definition/Akkordeon/2b.png',
                alt: '',
                width: '150px',
                height: '281px',
                subtitle: 'sondern eine einzige',
              },
            ]
          },
          {
            header: 'Es geht nicht um lange Listen, sondern um machbare',
            text: 'Es gibt Organisationen, die bieten über 60.000 Reiseziele an. Man könne ja individuell auswählen. Richtig, nur welchen Wert haben sie als Reiseziele? Da man nur etwa 6.000 besuchen kann, wären das von 60.000 nur 10%. Für das Ziel, die ganze Welt zu sehen, ist dieses Angebot kontraproduktiv. Je länger, desto schlechter. ',
            images: [
              {
                src: '/Img/Definition/Akkordeon/3a.svg',
                alt: '',
                width: '150px',
                height: '150px',
                subtitle: 'Nicht lang',
              },
              {
                src: '/Img/Definition/Akkordeon/3b.svg',
                alt: '',
                width: '120px',
                height: '120px',
                subtitle: 'sondern machbar',
              },
            ]
          },
          {
            header: 'Es geht nicht nur um populäre Ziele, sondern vor allem um wesentliche Ziele',
            text: 'Auch wir berücksichtigen die Besucherzahl und respektieren so das Urteil vieler. Aber nicht per se. Es müssen andere Kriterien hinzukommen. Wenn eine Stadt nicht viel zu bieten hat, aber einen Vergnügungspark, wird dieser Ort in der Google-Highlightliste eine hohe Position haben, bei uns wird er nicht auftauchen. Um das Wesentliche zu erkennen, braucht man Systematik und den Überblick, eine Methodik und nicht ständig wechselnde Beurteilende mit unterschiedlichen Ansichten. ',
            images: [
              {
                src: '/Img/Definition/Akkordeon/4a.jpg',
                alt: '',
                width: '150px',
                height: '139px',
                subtitle: 'Nicht viele likes',
              },
              {
                src: '/Img/Definition/Akkordeon/4b.jpg',
                alt: '',
                width: '150px',
                height: '112px',
                subtitle: 'sondern wesentlich',
              },
            ]
          },
        ]
      },
      liste: {
        align: false,
        buttonLink: 'worldlist',
        buttonText: 'Zur Liste',
        color: 'fire',
        img: {
          src: [
            '/Img/Welcome/03_Liste.webp', // Preferred WebP (for Mockups)
            '/Img/Welcome/03_Liste.png'   // Fallback JPG/PNG
          ],
          alt: '',
          width: '558px',
          height: '398px'
        }
      },
    },

    // ==================== LISTE
    list: {
      hero: {
        subtitle: 'Die Tabelle im Internet',
        // h1: 'Frank Grosse World Highlight List',
        img: {},
      },
      erlaeuterung: {
        element: 'TwoColumn',
        text: [
          '<strong>Der Begriff Liste</strong>: Er wird hier im umfassenden Sinn gebraucht.<br><br>' +
          'Die Liste der Welthighlights umfasst drei Formen:<br><br>' +
          '<ul><li><strong>Tabellenform</strong>: Die zentrale Form der Liste. Ihr Ziel ist die Definition des Highlights. Mehr als 90.000 Seiten, wenn man die Liste, ihre Daten und Fotos im Platzbedarf in nur einer Sprache umrechnet.<br><br><li><strong>Namensliste</strong>: Eine übersichtliche Form zur Zuordnung zur Region und dem Welterbe. Sie eignet sich für eine persönliche Erfassung des Gesehenen. Ungefähr 100 Seiten. <br><br><li><strong>Summenliste</strong>: Sie erfasst die Anzahl der Highlights je Kontinent und je Land, unterteilt nach Gruppen, daneben die Anzahl der Welterben in der UN-Definition und in der Definition der Besuchsziele. Ungefähr 8 Seiten.</ul>',
          '<strong>Zur Tabellenform</strong>: Sie ist das Kernprodukt unseres Reisewerks: 5 Bücher und die Webseite. Für den Nutzer, der wiederholt auf die Liste möchte, ist die Webseite so gestaltet, dass er mit zwei Klicks auf die Liste kommt. Für den Nutzer, der sich über das Fundament der Liste informieren will, ist die Grafik hierarchisch gestaltet: Vom Oberpunkt zum Unterpunkt.<br /><br />' +
          '<strong>Ziel der Liste</strong>: Interaktive Auswahl des Highlights und Analyse seines Wesens durch Beschreibung, Lokalisierung und Kategorisierung.<br /><br />' +
          '<strong>Analyse des Wesens</strong> durch Kategorisierung in bis zu 4 Dimensionen mit 1.500 Kategorien.<br /><br />' +
          '<strong>Eingabe der Kategorie</strong> vergleicht das Highlight mit allen anderen in derselben Kategorie.<br /><br />' +
          '<strong>Rangfolgebestimmung</strong> der Highlights je Kategorie (steht noch am Anfang).'
        ],
      },
      erlaeuterung2: {
        h2: 'Erläuterung',
        align: false,
        // text: [
        //   '<strong>Der Begriff Liste</strong>: Er wird hier im umfassenden Sinn gebraucht.<br><br>',
        //   'Die Liste der Welthighlights umfasst drei Formen:<br><br>',
        //   '<ul><li><strong>Tabellenform</strong>: Die zentrale Form der Liste. Ihr Ziel ist die Definition des Highlights.<br><br><li><strong>Namensliste</strong>: Eine übersichtliche Form zur Zuordnung zur Region und dem Welterbe. Sie eignet sich für eine persönliche Erfassung des Gesehenen.<br><br><li><strong>Summenliste</strong>: Sie erfasst die Anzahl der Highlights je Kontinent und je Land, unterteilt nach Gruppen, daneben die Anzahl der Welterben in der UN-Definition und in der Definition der Besuchsziele.</ul>',
        // ],
        img: {
          src: '/Img/Liste/01 Ewe-Dorf in Togo.jpg',
          alt: '',
          width: '450px',
          caption: 'Ewe-Dorf in Togo',
        },
        img2: {
          src: '/Img/Liste/02 Bamberger Rathaus.jpg',
          alt: '',
          width: '450px',
          caption: 'Bamberger Rathaus',
        }
      },
      spacer: {
        element: 'SingleColumn',
      },
      benutzung: {
        element: 'SingleColumn',
        h2: 'Benutzung',
        width: 60,
        align: true,
        text: [
          'Die vorstehende Tabelle ist umfassend, aber extrem benutzerfreundlich ohne jeglichen Fachjargon. Sie ist interaktiv, ihre Auswahl berücksichtigt die logischen Verbindungen zu anderen Kriterien. Wählt man Deutschland aus, dann erscheint unter „Kontinent“ Europa, weil Deutschland nur in Europa Landbesitz hat. Wählt man Großbritannien aus, dann erscheinen unter „Kontinent“ alle Kontinente, in denen Großbritannien Landbesitz hat.<br><br>',
          '<strong>Bildschirmoptimierung</strong> für die Tabellenform:<br> Den Anforderungen einer matrixartigen Tabellenform folgend optimieren wir für Computerbildschirme. Wer die Liste nur mit einem Handy-Display liest, wir nicht den vollen Nutzen erhalten, das liegt in der Natur einer Tabelle.<br><br>',
          '<strong>Bewertung der Highlights</strong>: Die Eigenschaften eines Highlights werden nicht nur isoliert bewertet, sondern immer auch aus der Sicht des Reisenden: Das Gesamterlebnis, der Bezug zum Land und zur Umwelt, die Bereicherung des Reisenden. Beispiel Restaurants: Michelin bewertet das Gericht, wir übernehmen das Urteil setzen es aber in Beziehung zum Gesamterlebnis.<br><br>',
          '<strong>Definition der Highlights</strong>: Auch hier spielt die Sicht des Reisenden eine entscheidende Rolle: Wo liegt es, wie komme ich hin, wie bedeutend ist es. Die Tabelle enthält eine eindeutige Lokalisierung und den Ausgangsort zum Besuch.  Vor allem bei weniger bekannten Plätzen soll der Name auf das Wesen schließen lassen.<br />Beispiel: 500 UNESCO-Welterben sind Schutzgebiete. Wir redefinieren sie als geografisch klare Besuchsziele, in denen sich das Wesen des Welterbes erschließt.'
        ],
      },
      disclaimer: {
        element: 'TwoColumn',
        text: [
          '<strong>Disclaimer:</strong><br>Die Auswahl der Highlights pro Kategorie ist größtenteils abgeschlossen, aber die Festlegung der Rangfolge innerhalb der einzelnen Kategorien befindet sich noch in einem frühen Stadium.',
          '<strong>Tour:</strong><br>Wir haben in einer „Tour“ alle Erläuterungen zusammengestellt. Klicken Sie auf Tour und überzeugen Sie sich, wie einfach, übersichtlich und aussagefähig die Tabelle ist.'
        ],
        button2Text: 'Tour',
      },
      spacer4: {
        element: 'SingleColumn',
      },
      spacer5: {
        element: 'SingleColumn',
      },
      ergaenzungen: {
        element: 'BoxImage',
        align: true,
        EnumerateTag: 'li',
        h2: 'Ergänzungen zur Liste',
        textbutton: [
          {
            text: 'Highlights: Namensliste',
            buttonText: 'LINK',
            buttonLink: 'name_list'
          },
          {
            text: 'Highlights: Summenliste',
            buttonText: 'LINK',
            buttonLink: 'sum_list'
          },
          {
            text: 'Kategorienliste',
            buttonText: 'LINK',
            buttonLink: 'category_list'
          },
          {
            text: 'Welterbeliste und Besuchsziele',
            buttonText: 'geplant',
            buttonLink: ''
          },
        ],
        // img: {
        //   src: [
        //     '/Img/Welcome/03_Liste.webp', // Preferred WebP (for Mockups)
        //     '/Img/Welcome/03_Liste.png'   // Fallback JPG/PNG
        //   ],
        //   alt: '',
        //   width: '558px',
        //   height: '398px'
        // }
      },
    },

    // ================== ABOUT
    about: {
      hero: {
        subtitle: 'Über uns',
        h1: 'Die Partner',
        img: {
          src: '/Img/About/Panorama.jpg',
          alt: '',
          caption: 'Lesotho, Maletsunyane Falls',
        },
      },
      widmung: {
        element: 'Box',
        EnumerateTag: 'p',
        h2: 'Widmung',
        color: 'gray',
        textAlign: 'justify',
        sectionBackgroundCss: 'sectionBackgroundTextBlack',
        text: [
          '',
          'Meine Bücher „Reiselust“ und meine Webseite widme ich meinem 2021 verstorbenen Lebenspartner',
          '<strong>Teodoro L. Murallon, MD</strong>',
          'von 2006 bis 2019 mein Reisepartner, mit dem ich höchste Reiselust erlebt habe.',
          'Es ist wahr: Geteilte Freude ist doppelte Freude. Bevor er Deutscher wurde, war er Filipino, ein Volk, das für Anpassungsfähigkeit und Lebensfreude steht. Teo war dafür ein Musterbeispiel. Er setzte aber auch seine eigenen Akzente: Bei unserer zwölftägigen Südpolreise war er allen überlegen.',
          'Hier erlebten wir das Wunder: Wir wurden Eins.',
          '<strong>Das Glück, einen solchen Reisepartner gehabt zu haben, ist unermesslich und ewig.</strong>',
        ]
      },
      partner: {
        element: 'TwoColumn',
        // h2: 'Die Partner',
        // width: 80,
        text: [
          '<strong>Dr. Frank W. Grosse-Oetringhaus</strong>: Unternehmensberater und Top-Managementausbilder bei Siemens, schrieb das Führungssystem für Siemens, entwickelte eine Lehre zur Strategie, 18 Jahre Dozent an der Uni St. Gallen, reist seit dem 16. Lebensjahr, insgesamt 26 Jahre „on the road“.<br /><br />' +
          '<strong>Teo Murallon</strong>: Facharzt für Anästhesie, praktizierte in den Philippinen, Krankenpfleger in New York und Berlin, pflegte die Mutter von Frank bis zu ihrem Tod, so entstand die Partnerschaft, reiste seit dem 35. Lebensjahr, insgesamt 13 Jahre „on the road“, starb an Corona in der Charité – dem besten Krankenhaus - am 12.3.2021.<br /><br />' +
          '<strong>Unsere Stärken:</strong><br />Frank: Kreativität, Organisation, Zielstrebigkeit<br />Teo: Empathie, emotionale Intelligenz, Anpassungsfähigkeit<br /><br />' +
          '<strong>Unsere Komplementarität:<br /></strong>Wir waren sehr verschieden, aber unsere Stärken ergänzten sich ideal, der Grund für unseren Erfolg'
        ],
        img: {
          src: '/Img/About/1a Yin Yang Filled.png',
          alt: '',
          width: '500px',
          style: { backgroundColor: 'transparent', marginTop: '100px' }
          // height: '253px'
        },
      },
      // partner: {
      //   element: 'SingleColumn',
      //   h2: 'Die Partner',
      //   width: 80,
      //   text: [
      //     '<strong>Dr. Frank W. Grosse-Oetringhaus</strong>: Unternehmensberater und Top-Managementausbilder bei Siemens, schrieb das Führungssystem für Siemens, entwickelte eine Lehre zur Strategie, 18 Jahre Dozent an der Uni St. Gallen, reist seit dem 16. Lebensjahr, insgesamt 26 Jahre „on the road“.<br /><br />',
      //     '<strong>Teo Murallon</strong>: Facharzt für Anästhesie, praktizierte in den Philippinen, Krankenpfleger in New York und Berlin, pflegte die Mutter von Frank bis zu ihrem Tod, so entstand die Partnerschaft, reiste seit dem 35. Lebensjahr, insgesamt 13 Jahre „on the road“, starb an Corona in der Charité – dem besten Krankenhaus - am 12.3.2021.<br /><br />',
      //     '<strong>Unsere Stärken:</strong><br />Frank: Kreativität, Organisation, Zielstrebigkeit<br />Teo: Empathie, emotionale Intelligenz, Anpassungsfähigkeit<br /><br />',
      //     '<strong>Unsere Komplementarität:<br /></strong>Wir waren sehr verschieden, aber unsere Stärken ergänzten sich ideal, der Grund für unseren Erfolg',
      //   ],
      // },
      partner2: {
        align: false,
        // img: {
        //   src: '/Img/About/1a Yin Yang Filled.png',
        //   alt: '',
        //   width: '500px',
        //   style: { backgroundColor: 'transparent' }
        //   // height: '253px'
        // },
        img2: {
          src: '/Img/Welcome/05_Harmonie.jpg',
          alt: '',
          width: '500px',
          caption: 'Harmonie',
        },
      },
      spacer: {
        element: 'SingleColumn',
      },
      partnerschaft: {
        h2: 'Reisen in Partnerschaft',
        text: [
          '<strong>Die Philosophie</strong>: Wir hatten dieselbe Reisephilosophie, daher waren die gemeinsamen Reisen voller Harmonie<br /><br />',
          '<strong>Der Sinn</strong>: Wir haben alle 7 Sinnkategorien erfahren: Staunen, Wesentliches, Bildung, Lebensintensität, Leistungsgrenzen, Spiritualität, Selbstverantwortung und Selbsterfahrung.<br /><br />',
          '<strong>Das Ziel</strong>: Die ganze Welt<br /><br />',
          '<strong>Der Stil</strong>: Intensiv und systematisch<br /><br />',
          '<strong>Der Erfolg</strong>: <br />13 Jahre gemeinsame Reisen<br />8 Jahre ununterbrochen<br />4.016 gemeinsam erlebte Highlights<br /><br />',
        ],
        img: {
          src: '/Img/About/3 Mt. Everest.jpg',
          alt: '',
          width: '450px',
          caption: 'Gemeinsame Leidenschaft für Extreme',
        }
      },
      spacer2: {
        element: 'SingleColumn',
      },
      schock: {
        h2: 'Der Schock',
        align: false,
        text: [
          '<strong>Der Grund:</strong> 2019 bis 2021 hatten wir das Reisen unterbrochen, bedingt durch Herzprobleme und Corona. In dieser Zeit schrieb ich ein umfassendes Buch über extremes Reisen. Wir infizierten uns mit Covid 19 in Berlin im November 2020. Ich hatte ausreichend Abwehrkräfte, Teo nicht. Er wurde im Dezember intubiert, wir rangen 2.5 Monate um sein Leben. Er verstarb am 12. März 2021.<br /><br />',
          '<strong>Ein neuer Fokus</strong>: Wie konnte ich ohne ihn leben? Wir waren in 38 Jahren eine Einheit geworden. Ich habe ein halbes Jahr gebraucht, um zu verstehen, nicht auf das Negative zu sehen, sondern auf das Positive – nicht darauf, dass er nicht mehr da ist, sondern darauf, dass wir ein Glück in seltener Fülle zusammen hatten.<br /><br />',
          '<strong>Eine neue Grundlage</strong>: In einem halben Jahr habe ich gelernt, diesen Gedanken zu verinnerlichen und wieder Glück zu empfinden. Geliehenes Glück aus der Vergangenheit als Grundlage für ein neues Glück in der Zukunft. <br /><br />',
          '<strong>Ein neuer Gedanke</strong>: Und ich tat in dieser Zeit noch mehr: Ich tat alles, was denkbar und möglich ist, dass Teo und ich uns nie trennen. Dieses Bewusstsein der Unzertrennlichkeit ist ein starker Gedanke für zukünftiges Glück.<br /><br />',
        ],
        img: {
          src: '/Img/About/4 Teo_.jpg',
          alt: '',
          width: '400px',
          caption: 'Teos 70. Geburtstag vor<br /> unserem Haus in Phuket',
        },
      },
      spacer3: {
        element: 'SingleColumn',
      },
      extremen: {
        h2: 'Das letzte Kapitel gilt Extremen',
        EnumerateTag: 'li',
        text: [
          [
            'Die „Bucket-List“ wird realisiert',
            'Erfahrung der beiden Vorbilder: Alexander des Großen und Alexander von Humboldt. 4 Gedächtnis-Reisen',
            'Zwei schwierige Länder vollständig bereisen: Irak und Saudi-Arabien',
            'Die führenden Luxusresorts: The Brando, Kaibu Fiji Private Islands, Laucala Island, Likuliku lagoon, Wakaya Club & Spa, Le Bora Bora, Le Taha\'a, Vahine Private Island',
          ],
          [
            'Fast alle Lücken wurden gefüllt',
            '734 neue Highlights in 43 Ländern (2021-2025)',
            'Gesehen: Alle Highlightgruppen und Welterben über 90% (2025: 90-95%)',
          ],
        ],
        img2: {
          src: '/Img/About/5 Reisefreude.jpg',
          alt: '',
          width: '450px',
          caption: 'Wir haben es erreicht!',
        },
        img: {
          src: '/Img/About/6a Leistungsgrenze.jpg',
          alt: '',
          width: '450px',
          caption: 'Yanomami ziehen mich über einen<br>Baumstamm mit 1,2 m Höhe',
        },
      },
      extremen_text: {
        element: 'SingleColumn',
        width: 70,
        align: false,
        EnumerateTag: 'li',
        text: [
          [
            'Auch ohne Partner wurde ich glücklich',
            'Die Pilgerreise Umrah erleben',
            'Die Yanomami verzaubern',
            'Den Casiquiare vermessen',
            '38 Tepuis in 6 Tagen: Überfliegen, Landen, Übernachten'
          ],
          [
            'Die Kernpunkte des Reisekonzepts wurden überprüft',
            '<strong>Reisefreude</strong> auch unter schwierigen Bedingungen',
            'Das <strong>Extrem realisieren</strong>: 6000 in 12 Jahren bedeutet 1,4 Highlights pro Tag.<br />Das Extrem: 5,5 Highlights am Tag in Europa und in Freude.',
            '<strong>Grenzen der Leistung</strong>: Yanomami ziehen mich über Baumstamm mit 1,2 m Höhe',
            '<strong>Ethisches Reisen</strong> weiterentwickeln: Papua Neu Guinea, Sokotra, Afghanistan',
          ]
        ],
      },
      karriere: {
        h2: 'Das Ende meiner Karriere',
        align: false,
        text: [
          '<strong>Endziele</strong>: Vollendung der Weltliste, Veröffentlichung der Bücher, Studium von Vorbildern, Genuss des Lebens.<br /><br />',
          '<strong>Mein Resümee</strong>: Ich habe mich von allen Wettbewerben gelöst. Beim Reisen wollte ich nicht bessere Qualität, sondern Qualität an sich. Ich habe alle meine Ziele erreicht, wenngleich Teo mir fehlt. Mit ihm war ich sehr glücklich. Das „sehr“ fehlt jetzt. Ich habe geliebt, geholfen und die ganze Welt gesehen.<br /><br />',
        ],
        img: {
          src: '/Img/About/7 Frank.jpg',
          alt: '',
          width: '350px',
          // caption: '',
        },
        // img2: {
        //   src: '/Img/About/7 Frank.jpg',
        //   alt: '',
        //   width: '350px',
        //   // caption: '',
        // },
      },
      karriere_texts: {
        element: 'SingleColumn',
        width: 70,
        text: [
          '<strong>Das Lebensmodell</strong>: Die drei Lebensziele lieben, helfen und reisen waren in der Tat die wichtigsten. Erst den Schwerpunkt auf lieben und helfen zu legen und dann schwerpunktmäßig zu reisen, war richtig.<br /><br />',
          '<strong>Der Luxus</strong>: Ich begann mit Trampen, ich habe meine Karriere in extremem Luxus beendet. Ich wollte die volle Breite. Aber noch mehr:  Ich habe nach sinnvollem Luxus gesucht und ihn gefunden: <i>Produktiver Luxus</i> – er verbessert sein Umfeld, er gibt mehr als er nimmt. Das heißt: Würde das Luxusresort verschwinden, wäre das Umfeld besser als zuvor. Das trifft auf die besten Luxusresorts der Welt zu: The Brando, Kaibu, Laucala. Sie stehen für <i>Naturgenuss</i>. Alexander von Humboldt erfand den Begriff <i>Naturgenuss</i> und zeigte damit den Weg des Reisens auf. Ich bin diesen Weg zu Ende gegangen. An diesen Orten erlebt man ihn in absoluter Vollendung. <br /><br />',
          '<strong>Die Spiritualität</strong>: Sie  hat wie bei den meisten im Alter eine hohe Bedeutung bekommen. Ich habe zur Multireligiosität  gefunden. Ich habe vier Religionen angenommen: Buddhismus, Christentum, Islam und Animismus (Flüsse), aber gehöre keiner religiösen Gemeinschaft an. Diese Haltung ist Grundlage meiner Toleranz, der Schlüssel zum erfolgreichen Reisen.<br /><br />',
        ],
      },
      bewertung: {
        element: 'BoxImage',
        align: true,
        EnumerateTag: 'li',
        h2: 'Unsere Bewertung',
        textbutton: [
          {
            text: 'Meine gesehenen Highlights: Summenliste',
            buttonText: 'PDF',
            buttonLink: '/pdf/561 Summenliste Gesehen.pdf'
          },
          {
            text: 'Meine und Teos Bewertung',
            buttonText: 'PDF',
            buttonLink: '/pdf/562 Meine und Teos Bewertung.pdf'
          },
          {
            text: 'Die Ziele unserer Reisepartnerschaft ',
            buttonText: 'PDF',
            buttonLink: '/pdf/563 Ziele der Reisepartnerschaft.pdf'
          },
          {
            text: 'Wie Reisende uns bewerten',
            buttonText: 'PDF',
            buttonLink: '/pdf/564 Wie andere uns bewerten.pdf'
          },
        ],
        img: {
          src: '/Img/About/8.jpg',
          alt: '',
          width: '558px',
          // height: '398px',
          caption: 'Mainamati, Ragban Vihar, Bangladesh',
        }
      },
      vermaechtnisse: {
        element: 'BoxImage',
        align: false,
        EnumerateTag: 'li',
        h2: 'Vermächtnisse',
        textbutton: [
          {
            text: 'Teos Vermächtnis',
            buttonText: 'PDF',
            buttonLink: '/pdf/2 Teos Vermaechtnis.pdf'
          },
          {
            text: 'Gemeinsames Vermächtnis',
            buttonText: 'PDF',
            buttonLink: '/pdf/3 Gemeinsames Vermaechtnis.pdf'
          },
          {
            text: 'Mein Vermächtnis',
            buttonText: 'PDF',
            buttonLink: '/pdf/4 Mein Vermaechtnis.pdf'
          },
        ],
        // img: {
        //   src: '/Img/About/8.jpg',
        //   alt: '',
        //   width: '558px',
        //   // height: '398px',
        //   caption: 'Mainamati, Ragban Vihar, Bangladesh',
        // }
      },      
    },

    // =========== KONZEPT
    concept: {
      hero: {
        subtitle: 'Das Erreichen von Extremen',
        h1: 'Das Konzept',
        text: [
          'Der Weltliste liegt ein systematisches <strong>Konzept</strong> zugrunde, aus dem wir hier einige Gedanken vorstellen, Ausschnitte, die neugierig machen sollen auf die <strong>Bücher</strong>. Die <strong>ersten beiden Bände</strong> erläutern das Konzept (Bd. 1) und seine Umsetzung (Bd.2) vollständig.<br /><br />',
          'Die Webseite ist aktuell in der <strong>Testphase</strong>, in der wir die Reaktionen sortieren. In dieser Zeit werden auch die <strong>Bücher</strong> erhältlich sein. Zunächst werden Abschnitte der Elemente „Konzept“, „Unsere Reisen“ und „Unsere Bewertung“ noch als <strong>pdf</strong> dargestellt. Je nach Reaktion werden wir Anpassungen vornehmen. In der Testphase werden die Webseite und die Bücher auch auf <strong>Englisch</strong> erscheinen.'
        ],
        EnumerateTag: 'p',
        img: {
          src: '/Img/Konzept/Panorama.jpg',
          alt: '',
          caption: 'Start zum Flug auf den Tepui Aprada, Venezuela',
        },
      },
      kopf: {
        element: 'BoxImage',
        align: true,
        EnumerateTag: 'li',
        //h2: 'Ergänzungen zur Liste',
        textbutton: [
          {
            text: 'Unser Oberziel: Höchstleistung',
            buttonText: 'PDF',
            buttonLink: '/pdf/1 Unser Oberziel Die Hoechstleistung.pdf'
          },
          {
            text: 'Unser Oberziel: Reiselust',
            buttonText: 'PDF',
            buttonLink: '/pdf/2 Unser Oberziel Die Freude.pdf'
          },
          {
            text: 'Unser Logo: Die Kerngedanken',
            buttonText: 'PDF',
            buttonLink: '/pdf/3 Unser Logo Die Kerngedanken.pdf'
          },
          {
            text: 'Definition der Welt-Highlights',
            buttonText: 'PDF',
            buttonLink: '/pdf/4 Definition der Welthighlights.pdf'
          },
          {
            text: 'Kategorisierung der Welt (Taxonomie)',
            buttonText: 'PDF',
            buttonLink: '/pdf/5 Kategorisierung der Welt.pdf'
          },
          {
            text: 'Rangfolge der Highlights je Kategorie',
            buttonText: 'PDF',
            buttonLink: '/pdf/6 Rangfolge der Highlights je Kategorie.pdf'
          },
        ],
        img: {
          src: '/Img/Konzept/Kopf.jpg',
          alt: '',
          width: '300px',
          height: '431px',
          caption: 'Der Louvre',
        }
      },
      karriere_texts: {
        element: 'SingleColumn',
        h2: 'Unsere Alleinstellungsmerkmale',
        width: 80,
        align: false,
        text: [
          '<strong>Das größte Reisewerk der Welt</strong>: >90.000 Seiten',
          '<strong>Das Reisewerk der Höchstleistungen</strong>: 6.000 Highlights in 12 Jahren',
          '<strong>Das einzige Werk über Reiselust</strong>: Freude als Oberziel',
          '<strong>Ein Reisewerk mit Beweis</strong>: 90% von 6.380 Highlights',
          '<strong>Ein Reisewerk aus einem Guß</strong>: Systematisch und konsistent',
          '<strong>Spagat aus Effizienz und Qualität</strong>: 1,4 Highlights pro Tag mit Freude',
          '<strong>Die Liste zur ganzen Welt</strong>: 1.500 Kategorien: Die ganze Welt',
          '<strong>Die ultimative Liste</strong>: Umfassend und objektiv',
          '<strong>Maßstab für Benutzerfreundlichkeit</strong>: Interaktiv, intuitiv, frei zugänglich',
        ],
      },
    },

    // ================= REISEN
    travels: {
      hero: {
        subtitle: 'Freude über Extreme',
        h1: 'Unsere Reisen',
        img: {
          src: '/Img/Reisen/Panorama.jpg',
          alt: '',
          caption: 'Rijal Almaa, Saudi Arabien',
        },
      },
      overview: {
        element: 'BoxImage',
        align: true,
        EnumerateTag: 'li',
        //h2: 'Ergänzungen zur Liste',
        text: [
          'Reisen zu extremen Orten',
          'Reisen auf extremen Wegen',
          'Reisen wegen extremer Themen',
          'Reiseergebnis: Listen der Spitzenplätze',
          'Ethisches Reisen',
          'Reisen auch um unser Konzept zu testen',
          'Gedächtnisreisen Alexander der Große',
          'Gedächtnisreisen Alexander von Humboldt',
        ],
        img: {
          src: '/Img/Reisen/00.jpg',
          alt: '',
          width: '300px',
          height: '458px',
          caption: 'Bamiyan',
        }
      },
      travel1: {
        h2: 'Reisen zu extremen Orten',
        align: false,
        text:
          [
            'Südpol',
            'Nordpol',
            'Russische Arktis',
            'Russisch Fernost',
            'Das Horn von Afrika',
            'Bouvet Insel',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/41 Traveling to extreme sites.pdf',
        externalLink: true,
        buttonText: 'Reisebericht',
        img: {
          src: '/Img/Reisen/1.jpg',
          alt: '',
          width: '558px',
          height: '314px',
          caption: 'Kap Horn',
        }
      },
      travel2: {
        h2: 'Reisen auf extremen Wegen',
        text:
          [
            'Aksai Chin Route, China',
            'Dogon, Mali',
            'Herz der Sahara',
            'Antarktische Halbumrundung',
            'Arktische Umrundung',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/42 Traveling extreme routes 9 slides.pdf',
        externalLink: true,
        buttonText: 'Reisebericht',
        img: {
          src: '/Img/Reisen/2.jpg',
          alt: '',
          width: '558px',
          // height: '313px',
          caption: 'Unterwegs in Russisch Fernost',
        }
      },
      travel3: {
        h2: 'Reisen wegen extremer Themen',
        align: false,
        text:
          [
            'Sakura in Japan',
            'Entwicklung der Menschheit',
            'Goldgewinnung',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/43 Traveling for extreme themes 4 slides.pdf',
        externalLink: true,
        buttonText: 'Reisebericht',
        img: {
          src: '/Img/Reisen/3.jpg',
          alt: '',
          width: '558px',
          // height: '313px',
          caption: 'Sakura in Kyoto',
        }
      },
      travel4: {
        h2: 'Reiseergebnis: Listen der Spitzenplätze',
        text:
          [
            'Ethnien',
            'Religiöse Stätten',
            'Feste',
            'Authentisches Essen',
            'Tierbegegnungen',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/44 Travel Results Lists of the Top Places 6 slides.pdf',
        externalLink: true,
        buttonText: 'Reisebericht',
        img: {
          src: '/Img/Reisen/4.jpg',
          alt: '',
          width: '558px',
          // height: '313px',
          caption: 'Bonobos in Kinshasa, DRC',
        }
      },
      travel5: {
        h2: 'Ethisches Reisen',
        align: false,
        text:
          [
            'Demonstrieren',
            'HDI unterstützen',
            'UNESCO unterstützen',
            'Helfen',
            'Erinnern',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/45 Ethisches Reisen.pdf',
        externalLink: true,
        buttonText: 'Reisebericht',
        img: {
          src: '/Img/Reisen/5.jpg',
          alt: '',
          width: '558px',
          // height: '313px',
          caption: 'Drachenbluternte, Sokotra',
        }
      },
      travel6: {
        h2: 'Reisen auch um unser Konzept zu testen',
        text:
          [
            'Reisefreude in schwierigen Ländern',
            'Das Testen der Anzahl von Highlights',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/46 Traveling for Testing our Concept 4 slides.pdf',
        externalLink: true,
        buttonText: 'Reisebericht',
        img: {
          src: '/Img/Reisen/6.jpg',
          alt: '',
          width: '350px',
          // height: '313px',
          caption: 'Derwische, Konya, Türkei',
        }
      },
      travel7: {
        h2: 'Gedächtnisreisen: Alexander der Große',
        align: false,
        text:
          [
            'Griechenland',
            'Türkei',
            'Afghanistan',
            'Pakistan',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/47 Memorial Travels for Alexander the Great 5 slides.pdf',
        externalLink: true,
        buttonText: 'Reisebericht',
        img: {
          src: '/Img/Reisen/7.jpg',
          alt: '',
          width: '300px',
          // height: '313px',
        }
      },
      travel8: {
        h2: 'Gedächtnisreisen: Alexander von Humboldt',
        text:
          [
            'Geschichte der Reise',
            'Venezuela Casiquiare, Vermessung',
            'Venezuela Yanomami',
            'Venezuela Orinoco-Flusssystem',
            'Venezuela Llanos',
            'Venezuela Las Aves',
            'Die Tafelberge von Venezuela',
          ],
        EnumerateTag: 'li',
        buttonLink: '/pdf/48 Memorial Travels for Alexander von Humboldt 17 slides.pdf',
        externalLink: true,
        buttonText: 'Reisebericht',
        img: {
          src: '/Img/Reisen/8.jpg',
          alt: '',
          width: '300px',
          // height: '313px',
        }
      },
    },

    // ================ BOOK
    book: {
      hero: {
        //subtitle: 'x',
        h1: 'Die Bücher',
        // text: [
        //   'Im folgenden erhalten sie eine detaillierte Erklärung unseres Reisekonzepts'
        // ],
        // EnumerateTag: 'p',
        img: {},
      },
      kopf: {
        element: 'BoxImage',
        align: true,
        EnumerateTag: 'li',
        //h2: 'Ergänzungen zur Liste',
        textbutton: [
          {
            text: 'Die Marke steht für ein Reisewerk',
            buttonText: 'PDF',
            buttonLink: '/pdf/61 Die Marke steht fuer ein Reisewerk.pdf'
          },
          {
            text: 'Überblick über die 5 Bände',
            buttonText: 'PDF',
            buttonLink: '/pdf/62 Ueberblick ueber die 5 Baende.pdf'
          },
          {
            text: 'Buchdeckel Band 1',
            buttonText: 'PDF',
            buttonLink: '/pdf/63 Buchdeckel Band 1.pdf'
          },
          {
            text: 'Inhaltsverzeichnis Band 1',
            buttonText: 'PDF',
            buttonLink: '/pdf/64 Inhaltsverzeichnis Band 1.pdf'
          },
          {
            text: 'Leseprobe: Band 1, S. 7-11',
            buttonText: 'PDF',
            buttonLink: '/pdf/65 Leseprobe Die drei grundlegenden Gedanken.pdf'
          },
          {
            text: 'Buchdeckel Band 2',
            buttonText: 'PDF',
            buttonLink: '/pdf/66 Buchdeckel Band 2.pdf'
          },
          {
            text: 'Inhaltsverzeichnis Band 2',
            buttonText: 'PDF',
            buttonLink: '/pdf/67 Inhaltsverzeichnis Band 2.pdf'
          },
        ],
        img: {
          src: '/Img/Book/1.jpg',
          alt: '',
          width: '558px',
          // height: '398px',
          caption: 'Bibliothek, St. Gallen',
        }
      },
      spacer: {
        element: 'SingleColumn',
      },
      bestellung: {
        element: 'BoxImage',
        width: 90,
        align: false,
        h2: 'Reiselust: Band 1',
        img: {
          src: '/Img/Book/Reiselust.webp',
          alt: '',
          width: '300px',
          height: '424px',
        },
        text: [
          'Er entfaltet das Erfolgskonzept des Reisens. Er geht der grundlegenden Frage nach dem <i>Warum</i> und <i>Wozu</i> des Reisens nach. Im Zentrum steht der Sinn des Reisens – nicht als abstrakte Idee, sondern als handlungsleitende Kraft. Der Band definiert die Erfolgskriterien des Reisens und legt damit das theoretische Fundament für alles Folgende.',
          '<p style="margin-bottom: 0.5em;"></p>',
          'Band 1 und Band 2 bilden eine gedankliche Einheit. Sie stehen nicht nebeneinander, sondern sind ineinander verschränkt – als theoretischer Entwurf und praktische Entfaltung eines umfassenden Reisekonzepts. Dieses Konzept ist zugleich das Fundament der Webseite Frank Grosse World List.',
        ],
        textbutton: [
          {
            text: 'Bestellen Sie das Buch hier:',
            buttonText: 'Books on Demand',
            buttonLink: 'https://buchshop.bod.de/reiselust-frank-grosse-9783819210372'
          },
          {
            text: '',
            buttonText: 'Amazon',
            buttonLink: 'https://amzn.eu/d/3NZPERe',
            tooltip: 'Bei Amazon wird ein "Paperback" automatisch als "Taschenbuch" klassifiziert. Das ist falsch. Das Buch ist ein Großformat.'
          }
        ],
      },
      bestellung2: {
        element: 'BoxImage',
        width: 90,
        align: true,
        h2: 'Reiselust: Band 2',
        img: {
          src: '/Img/Book/Reiselust2.jpg',
          alt: '',
          width: '300px',
          height: '424px',
        },
        text: [
          'Er setzt dieses Fundament in Bewegung. Er beantwortet die Fragen nach dem <i>Wohin</i> und <i>Wie</i> – mit systematischen Zielübersichten, konkreten Wegweisern und einer intensiven Auseinandersetzung mit Grenzerfahrungen und Reisestil. Die gesamte Reisepraxis – von der Planung über die Durchführung bis zur Reflexion – wird methodisch durchdrungen und anhand bewährter Beispiele.',
          '<p style="margin-bottom: 0.5em;"></p>',
          'Band 1 und Band 2 bilden eine gedankliche Einheit. Sie stehen nicht nebeneinander, sondern sind ineinander verschränkt – als theoretischer Entwurf und praktische Entfaltung eines umfassenden Reisekonzepts. Dieses Konzept ist zugleich das Fundament der Webseite Frank Grosse World List.',
        ],
        textbutton: [
          {
            text: 'Bestellen Sie das Buch hier:',
            buttonText: 'Books on Demand',
            buttonLink: 'https://buchshop.bod.de/reiselust-frank-grosse-9783819212086'
          },
          {
            text: '',
            buttonText: 'Amazon',
            buttonLink: 'https://www.amazon.de/dp/3819212086',
            tooltip: 'Bei Amazon wird ein "Paperback" automatisch als "Taschenbuch" klassifiziert. Das ist falsch. Das Buch ist ein Großformat.'
          },
        ],
      },
      vorbestellung: {
        element: 'SingleColumn',
        width: 90,
        align: false,
        h2: 'Vorbestellung',
        text: [
          // '<div id="bodShopWidget_5596240_print" class="bodShopWidget">TEXT</div>',
          'Melden Sie sich mit folgenden Formular für die weiteren Bände vor.',
          '<iframe src="https://docs.google.com/forms/d/e/1FAIpQLSf--Dc8M6LEzguMw8qbEt8KwrpL1F43wSnglcCxN4fkFFUPgA/viewform?embedded=true" width="640" height="1000" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>'
        ],
      },
    },
    // =========== WELTMODELL
    model: {
      hero: {
        subtitle: 'Das Erfassen des Ganzen',
        h1: 'Die ganze Welt in 1500 Kategorien',
        EnumerateTag: 'p',
        img: {
          src: '/Img/Modell/Wide.png',
          alt: '',
        },
      },
      schoen1: {
        element: 'Line2',
        align: true,
        text: 'Das Schönste, das wir kennen, ist nicht ein Teil der Welt, sondern die Welt selbst.',
        text2: 'Geht es um Schönheit, dann siegt die Gesamtheit.',
        subtitle: 'Der schönste Planet im Kosmos',
        img: {
          src: '/Img/Modell/1_Earth rise.jpg',
          alt: '',
          width: '400px',
          caption: 'Apollo 8',
          captionStyle: 'imageCaptionSmall',
        }
      },
      schoen2: {
        element: 'Line2',
        align: false,
        text: 'Die Weltliste zerlegt die Welt in 6.000 Highlights.<br /><br />Das Weltmodell setzt die 6.000 Highlights wieder zu einer einzigen Welt zusammen.<br /><br />',
        text2: 'Das Weltmodell setzt die Welt aus den Rangfolgen der Top Ten Highlights jeder Kategorie zusammen.',
        subtitle: 'Der schönste Planet im Kosmos',
        img: {
          src: '/Img/Modell/2_Earth rise with moon.png',
          alt: '',
          width: '400px',
          caption: 'Generiert nach Apollo 8',
          captionStyle: 'imageCaptionSmall',
        }
      },  
      schoen3: {
        element: 'Line2',
        align: true,
        text: 'Die Weltliste zeigt die Quintessenz der Welt, das Einzigartige, ohne Wiederholungen: Welthighlights. Dennoch bleibt sie eine Auswahl von Highlights. Weil diese ortsgebunden sind, erfassen sie streng genommen nicht die Welt als Ganzes.<br /><br />',
        text2: 'Das Weltmodell erfasst auch alle Arten je Kategorie. Im Unterschied zu ortsgebundenen Highlights beziehen sich Arten, Stile, Typen und Phänomene auf die Welt als Ganzes.',
        subtitle: 'Der schönste Planet im Kosmos',
        img: {
          src: '/Img/Modell/3_Earthrise close with moon.png',
          alt: '',
          width: '400px',
          caption: 'Generiert nach Apollo 11',
          captionStyle: 'imageCaptionSmall',
        }
      },  
      schoen4: {
        element: 'Line2',
        align: false,
        text: 'Die Weltliste beantwortet die Frage: „Was ist bedeutend?“ Das Welthighlight.<br /><br />Das Weltmodell beantwortet die Frage: „Wozu gehört es?“ Die Weltkategorie.<br /><br />',
        text2: 'Ganzheitlichkeit ist die DNA des Weltmodells',
        subtitle: 'Die drei berühmtesten Erdfotos ("Blue Marble")',
        img: {
          src: '/Img/Modell/4_Blue Marble the Americas.png',
          alt: '',
          width: '400px',
          captionStyle: 'imageCaptionSmall',
        }
      },  
      schoen5: {
        element: 'Line2',
        align: true,
        text: 'Das Weltmodell erfasst die Einheit der Welt.<br /><br />Die Weltliste erfasst die Vielfalt der Welt.',
        text2: 'Das Konzept des Weltmodells erfasst die ganze Welt ohne Einschränkung. Seine Darstellung muss jedoch den verfügbaren Raum berücksichtigen.',
        subtitle: 'Die drei berühmtesten Erdfotos ("Blue Marble")',
        img: {
          src: '/Img/Modell/5_Blue Marble AfrikaEurope.png',
          alt: '',
          width: '400px',
          captionStyle: 'imageCaptionSmall',
        }
      },  
      schoen6: {
        element: 'Line2',
        align: false,
        text: 'Das Ganze steht über seinen Teilen.',
        text2: 'Alle, die das sahen, waren den Tränen nahe.',
        subtitle: 'Die drei berühmtesten Erdfotos ("Blue Marble")',
        img: {
          src: '/Img/Modell/6_Blue Marble AustraliaAsia.png',
          alt: '',
          width: '400px',
          captionStyle: 'imageCaptionSmall',
        }
      },  
      schoen7: {
        element: 'Line2',
        align: true,
        text: 'Die Menschheit im Kosmos ist einzigartig.<br /><br />Es gibt keinen gegenteiligen Nachweis.',
        text2: 'Daraus resultiert unsere Verantwortung.<br /><br />Die Verantwortung jedes Einzelnen.',
        subtitle: 'Erde bei Nacht ("Black Marble")',
        img: {
          src: '/Img/Modell/7_earth at night africa europe.png',
          alt: '',
          width: '400px',
          caption: 'Generiert in Anlehnung an reale Satellitenaufnahmen',
          captionStyle: 'imageCaptionSmall',
        }
      },
      listen: {
        element: 'BoxImage',
        align: false,
        EnumerateTag: 'li',
        // h2: 'Zum Weltmodell',
        textbutton: [
          {
            text: 'Zum Weltmodell mit seinen Extremen',
            buttonText: 'LINK',
            buttonLink: 'worldmodel_extremes'
          },
          {
            text: 'Zum Weltmodell mit seinen Rangfolgen',
            buttonText: 'LINK',
            buttonLink: 'worldmodel_rankings'
          },
        ]
      },      
    },
    // =====================
    error404: {
      h1: '404 - Seite nicht gefunden.',
      text: 'Die von Ihnen gesuchte Seite existiert nicht oder wurde verschoben.',
      link: 'Zurück zur Startseite',
    },
    texts: {
      list: {
        pages: 'Zeige {{count}} pro Seite',
        selection: 'Aktuelle Auswahl enthält {{count}} Highlights',
        selection_category: 'Aktuelle Auswahl enthält {{count}} Kategorien',
        selection_entries: 'Aktuelle Auswahl enthält {{count}} Einträge',
        page: 'Seite ',
        page_of: ' von {{count}}',
        page_size: 'Zeige {{count}} pro Seite',
        all: 'Alle',
        search: 'Suche...',
        kontinent: 'Kontinent',
        land: 'Land',
        region: 'Region',
        gruppe: 'Gruppe',
        title: 'Name des Highlights',
        kategorien: 'Kategorien',
        kategorie: 'Kategorie',
        welterbe: 'Welterbe',
        no1: 'Synoptisch<br>Nr. 1<br>Rang aus der Weltliste (vorläufig)',
        sum_standard: 'Standard',
        sum_top: 'Top',
        sum_mega: 'Mega',
        sum_wel_unique: "Welterbe (UNESCO-Definition)",
        sum_wel: "Welterbe (Besuchsziele)",
        chatgpt: "ChatGPT",
        chatgpt2: "ChatGPT2",
        ext_all: "Synoptische Rangfolge der ersten zehn Highlightorte aus der Weltliste (vorläufig)",
        ext_chatgpt: "Spezifische Rangfolge der ersten zehn Highlightorte",
        ext_chatgpt2: "Spezifische Rangfolge der ersten zehn Arten",
        ext_chatgpt3: "Spezifisch<br>Weltextrem<br>Superlativstärke"
      },
      highlight: {
        kontinent: 'Kontinent:',
        kontregion: 'Kontinentalregion:',
        land: 'Land:',
        landregion: 'Landregion:',
        Kategorien: 'Kategorien',
        Ausgangsort: 'Ausgangsort',
        Unterorte: 'Unterorte',
        Zusatzorte: 'Zusatzorte',
        Hotel: 'Hotel',
        Reisezeit: 'Reisezeit',
        UN1: 'UNESCO-Welterbe',
        UN2: 'Besuchsziel eines UNESCO-Welterbes',
        prev: 'Vorheriges Highlight',
        next: 'Nächstes Highlight',
        close: 'Schließen',
        UNTooltip: 'Liste öffnet in einem neuen Fenster/Tab',
        UNAll: 'Alle Highlights zu diesem Welterbe anzeigen',
        map_external: 'Große Karte und Fotos anzeigen',
        nomap: 'Um dieses Highlight direkt auf einer Google Karte zu sehen, müssen Sie der Verwendung von Cookies zustimmen. Bitte klicken Sie hier. Alternativ können Sie den Ort in einem neuen Tab öffnen.',
        nomap_cookie: 'Cookies akzeptieren',
        nomap_external: 'Externer Link',
      },
      impressum: {
        telefon: 'Telefon',
        email: 'Email',
        footer: 'Diese Seite dient keinen gesch&auml;ftlichen Zwecken, sie ist für jedermann frei zug&auml;nglich.<br />Sie erweitert die Bücher „Reiselust“ um zwei Dimensionen, die für den Buchdruck unm&ouml;glich sind: <b>Datenumfang</b> und <b>Interaktivit&auml;t</b>.',
        title1: 'Impressum',
        title2: 'Kontakt',
      },
      kommentare: {
        title: 'Kommentare',
        text: 'Ich würde mich freuen, wenn ich Sie zur Mitarbeit an der Frank Grosse World Highlights List® gewinnen könnte. Die Liste ist für Sie kostenlos. Auf der Webseite habe ich erläutert, dass die numerischen Rangfolgen der Highlights in einer Kategorie noch vollendet werden müssen. Bei über 6.000 Highlights ist das eine gewaltige Aufgabe. Aber darüber hinaus ist jede Hilfe zur Verbesserung sehr willkommen.<br /><br />Bitte teilen Sie mir Ihr Feedback mit folgendem Formular mit:',
      },
      cookie: {
        yes: 'Einverstanden',
        no: 'Nur notwendige',
        text: 'Diese Webseite verwendet technische notwendige Cookies sowie weitere um das Benutzungsverhaltung zu untersuchen.',
      },
      sumlist: {
        title: 'Die Weltliste als Summenliste: Anzahl der Welt-Highlights',
        text1: 'Highlights nach drei Gruppen, davon Welterbe im Original und als Besuchsziele',
        sumlabel: 'Gesamt',
      },
      categorylist: {
        title: 'Kategorienliste, systematisch (Taxonomie der Welt)',
        text1: 'Erläuterung: Oberbegriffe sind zweifach gekennzeichnet (1) gelb unterlegt (2) mit "generell" am Namensende; Oberbegriffe sind keine Kategorien. Sie dienen der deduktiven Ableitung. Die Liste wurde sowohl deduktiv (vom Abstrakten zum Besonderen) als auch induktiv erhoben. Sie erfasst die Vielfalt der Welt aus der Sicht des Reisenden; anders formuliert: In einer Kategorie gibt es mindestens 3 Welthighlights, höchstens 20. Ein Reisender oder eine Reisende sollte in allen Kategorien mindestens 1 Welthighlight, durchschnittlich 4 bis 5 gesehen haben. Dann hat er oder sie die ganze Welt gesehen.',
      },
      categorylist_extended: {
        title: 'Das Weltmodell mit seinen Rangfolgen',
        text1: [
          '<b>Erklärung</b>: Übergeordnete Begriffe werden markiert (1) hervorgehoben in Gelb (2) mit „general“ am Ende des Namens. Übergeordnete Begriffe sind keine Kategorien; sie dienen der deduktiven Ableitung und Strukturierung. Die Liste wird deduktiv (vom Abstrakten zum Spezifischen) und induktiv (vom real Existierenden zum Abstrakten, dem empirischen Prozess) erstellt.',
          'In einer Kategorie wollen wir wegen der Machbarkeit zwischen 3 und 20 Highlights, das hängt darüber hinaus von der Definition ab, die noch nicht endgültig ist, aber dem Ideal schon nahe kommt. Zur besseren Übersichtlichkeit haben wir alle Spalten auf 10 Highlights begrenzt.',
          '<b>Synoptisch</b>: Die synoptische Rangfolge berücksichtigt das ganze Kategoriesystem. Wenn eine Kategorie Unterkategorien umfasst, dann wird das hier berücksichtigt.',
          '<b>Spezifisch</b>: Die spezifische Rangfolge, als einzige mit KI generiert, orientiert sich nur am Begriff der Kategorie. Sie berücksichtigt also keine Unterkategorien.',
          '<b>Beispiel</b>: Die Kategorie "Gebäudearchitektur" wird in der Kategorieliste (siehe Weltliste) erläutert, dort steht der Hinweis: "profan". Das bedeutet: In der synoptischen Sicht sind die Sakralbauten, die eine Unterkategorie bilden, nicht enthalten, damit keine Doppelnennungen auftreten. Es werden also unter dem Begriff "Gebäudearchitektur" nur Profanbauten gezeigt. In der spezifischen Sicht dagegen werden alle Gebäudearchitekturen, also Profan- und Sakralbauten gezeigt. Damit treten Doppelnennungen auf.',
          '<b>Arten</b>: Spezies, Typen, Formen, Stile, Erscheinungen, Ausprägungen.',
          // '<b>Quelle</b>: Die Spalten 4 und 5 wurden mit KI gebildet, das erklärt die unterschiedliche Sichtweise. Die synoptische Sicht (nicht KI) ist der spezifischen Sicht (KI) immer überlegen.',
        ]
      },
      categorylist_extended2: {
        title: 'Das Weltmodell mit seinen Extremen',
        // text1 identical to categorylist_extended
        text2: [
          '<b>Superlativstärke</b>: Globaler Rang, Größenordnung des Extremwerts, Stabilität, Eindeutigkeit.',
        ],
      },
      namelist: {
        title: 'Namensliste',
        text1: 'In dieser Liste sind alle Highlights differenziert nach ihrer Bedeutung:',
        list1: [
          '2.000 Mega-Highlights – globale Mehrfach-Extreme - <span style="background-color: orange">orange unterlegt</span>',
          '2.000 Top-Highlights – globale Einfach-Extreme - <span style="background-color: gelb">gelb unterlegt</span>',
          '2.000 Standard-Highlights – regionale Extreme mit globaler Bedeutung  - <span>nicht unterlegt</span>',
        ],
        text2: 'Auf einen Blick:',
        list2: [
          'Welche Highlights hat das Land?',
          'Welche Highlights hat die Region?',
          'Welche Highlights sind Welterben?',
        ],
        text3: 'Symbole für die Beziehung zum Welterbe:',
        text4: [
          '28% der Highlights haben eine Beziehung zum UNESCO-Welterbe. Davon sind 60% identisch mit dem UNESCO-Welterbe (diese sind grün unterlegt: <span style="background-color: lightgreen">UN</span>) aber 40% haben eine veränderte Beziehung (diese sind nicht unterlegt: UN) weil das UNESCO-Welterbe keine oder keine sinnvollen Besuchsziele definiert: Deshalb verändern wir das UNESCO-Welterbe:',
          '(1) Es wird entweder um Besuchsziele erweitert: 17% (typisch für große Schutzgebiete)',
          '(2) oder es wird auf Besuchsziele fokussiert: 23% (typisch für zu viele "multi locations")',
          'Welterben, landesbezogen: 1.324 (Stand 2025). Frank Grosse: 1.812 Welterbe-Besuchsziele',
        ],
      }
    },
    joyride: {
      nav: {
        back: 'Zurück',
        close: 'Schließen',
        last: ' Schließen',
        next: 'Weiter',
        skip: 'Tour beenden',
      },
      steps: [
        {
          target: '#root',
          content: 'Willkommen in der Frank Grosse World Highlights List. Die folgende Tour erklärt, wie Sie in der Liste der 6000 Highlights navigieren.',
          disableBeacon: true,
          placement: 'center',
        },
        {
          target: '.table-header-Kontinent',
          content: 'Jede Zeile enthält ein Highlight. Die Highlights sind gruppiert: Nach Kontinent, ',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Land',
          content: 'die Länderliste ist eine erweiterte Liste der UN-Mitgliedstaaten, sie umfasst mehr als diese 193., ',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-LandRegion',
          content: 'Regionen innerhalb eines Landes, ',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Gruppe',
          content: 'Highlightart: Standard, Top und Mega, die jeweils 2000 Highlights enthalten, sowie ',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Beschreibung',
          content: 'Die Highlights sind nach einer geografischen Reihenfolge sortiert. Es beginnt immer mit den Highlights in der Hauptstadt. Dann nach sinnvollen geografischen Regionen: Nord, West, Süd, Ost. Es kann auch „Zentral“ hinzukommen. Bei lang gestreckten Ländern können es nur Nord und Süd oder Ost und West sein. Die Region ist im Highlight-Text angegeben.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Kategorien',
          content: 'und nach über 1500 Kategorien.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Kontinent span',
          content: 'Durch einen Klick auf die Titel (z.B. hier Kontinent) wird die Sortierung der Liste geändert (eine Pfeilspitze erscheint: nach oben zeigend bedeutet dies, die Länder sind alphabetisch aufsteigend sortiert, nach unten zeigend, sie sind alphabetisch absteigend sortiert). Ein zweiter Klick sortiert andersherum.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Kontinent select',
          content: 'Das Dropdown erlaubt die Auswahl einzuschränken.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.table-header-Beschreibung input',
          content: 'Es kann nach Begriffen gesucht werden.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.pagination_buttons',
          content: 'Mit den Pfeilen wird auf die nächsten Seiten geblättert: Einfacher Pfeil vorige oder nächste Seite, Doppelpfeil erste oder letzte Seite.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.pagination_pages',
          content: 'Die jeweilige Seite von der Gesamtzahl der Seiten von der aktuellen Auswahl.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '#pagination_perpage',
          content: 'Damit halten Sie die Tabelle übersichtlich, Sie wählen so viele Zeilen, wie Sie wirklich benötigen.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.pagination_currentselection',
          content: 'Die Highlights in der aktuellen Auswahl. Beispiel: Haben Sie bei Kontinent, Gruppe und Kategorien stets „alle“ ausgewählt und nur ein Land ausgewählt, dann zeigt es Ihnen die Gesamtzahl der Highlights dieses Landes.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '.pagination_tour',
          content: 'Wenn Sie diese Tour später wiederholen wollen, klicken Sie hier.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '#worldlist_table tr:nth-child(2) td:nth-child(5)',
          content: 'Ein Klick auf den Hightlightnamen ruft weitere Details auf.',
          disableBeacon: true,
          placement: 'bottom',
        },
        {
          target: '#root',
          content: 'Viel Spaß!',
          disableBeacon: true,
          placement: 'center',
        },
      ],
    },
    cookies: {
      //   // Main consent banner/popup/modal
      title: 'Einstellung zur Privatsphäre',  // Optional title
      //message: 'We use cookies to ensure the best experience, understand how the site is used, and support basic functionality. You can choose to accept all cookies or adjust your settings. Once consent has been granted, we and the third-party companies involved process your personal data for various purposes. Detailed information on the purpose, legal basis and third-party companies can be found under the ‘More information’ button and in our privacy policy. You can revoke your consent at any time.',
      message: 'Wir verwenden Cookies, um Ihnen ein optimales Erlebnis zu bieten, um zu verstehen, wie die Website genutzt wird, und um grundlegende Funktionen zu unterstützen. Sie können wählen, ob Sie alle Cookies akzeptieren oder Ihre Einstellungen anpassen möchten. Nach Erteilung der Einwilligung verarbeiten wir und die beteiligten Drittunternehmen Ihre personenbezogenen Daten. Detaillierte Informationen über den Zweck, die Rechtsgrundlage und die Drittunternehmen finden Sie in unserer Datenschutzerklärung. Sie können Ihre Einwilligung jederzeit widerrufen.',
      accept: 'Accept',
      decline: 'Decline',
      manage: 'Manage Cookies',
      //   privacyPolicyText: 'Privacy Policy',

      //   // Manage consent modal
      //   manageTitle: 'Cookie Preferences',
      //   manageMessage: 'Manage your cookie preferences below. Essential cookies are always enabled as they are necessary for the website to function properly.',

      //   // Essential cookies section
      //   manageEssentialTitle: 'Essential',
      //   manageEssentialSubtitle: 'Required for the website to function properly',
      //   manageEssentialStatus: 'Status: Always enabled',
      //   manageEssentialStatusButtonText: 'Always On',

      //   // Analytics cookies section
      //   manageAnalyticsTitle: 'Analytics',
      //   manageAnalyticsSubtitle: 'Help us understand how visitors interact with our website',

      //   // Social cookies section
      //   manageSocialTitle: 'Social',
      //   manageSocialSubtitle: 'Enable social media features and sharing',

      //   // Advertising cookies section
      //   manageAdvertTitle: 'Advertising',
      //   manageAdvertSubtitle: 'Personalize advertisements and measure their performance',

      //   // Status messages
      //   manageCookiesStatus: 'Status: {{status}} on {{date}}', // Supports variables
      //   manageCookiesStatusConsented: 'Consented',
      //   manageCookiesStatusDeclined: 'Declined',

      //   // Buttons in manage modal
      //   manageCancelButtonText: 'Cancel',
      //   manageSaveButtonText: 'Save Preferences'
    }
  },
};

export default i18n_de;

